import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start" }, "Filtrar Políticas", -1)
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-row gap-2" }
const _hoisted_4 = { class: "w-full order-2 md:order-1" }
const _hoisted_5 = { class: "w-[180px] order-1 md:order-2" }
const _hoisted_6 = { class: "w-[180px] order-1 md:order-2" }

import { ref, computed, watchEffect } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import GhostButton from '@/components/designSystem/Buttons/GhostButton/index.vue'
import { useToast } from 'vue-toastification'
import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'

interface AppliedFilters {
  companies: string[]
  isActive: 'active' | 'inactive' | ''
  authorizationStatus?: 'FULLY_AUTHORIZED' | 'PARTIALLY_AUTHORIZED' | ''
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterModal',
  props: {
    modalStateProp: { type: Boolean },
    showStatusFilter: { type: Boolean },
    showAuthorizationStatusFilter: { type: Boolean },
    appliedFilters: {}
  },
  emits: ['close', 'apply-filters'],
  setup(__props: any, { emit }) {

const props = __props;





const { listCompanies } = storeToRefs(useCompanyStore())
const toast = useToast()

const showStatusFilter = props.showStatusFilter ?? true
const showAuthorizationStatusFilter = props.showAuthorizationStatusFilter ?? true

const loading = ref(false)
const selectedCompanies = ref<string[]>([])
const searchCompany = ref('')
const selectedStatus = ref<'active' | 'inactive' | ''>('')
const selectedAuthorizationStatus = ref<'FULLY_AUTHORIZED' | 'PARTIALLY_AUTHORIZED' | ''>('')

const statusOptions = [
  { label: 'Todas', value: '' },
  { label: 'Ativas', value: 'active' },
  { label: 'Inativas', value: 'inactive' }
]

const authorizationOptions = [
  { label: 'Todos', value: '' },
  { label: 'Totalmente Autorizado', value: 'FULLY_AUTHORIZED' },
  { label: 'Parcialmente Autorizado', value: 'PARTIALLY_AUTHORIZED' }
]

const isFilterValid = computed(() => {
  const hasCompany = selectedCompanies.value.length > 0
  const hasStatus = showStatusFilter && selectedStatus.value !== ''
  const hasAuthorization = showAuthorizationStatusFilter && selectedAuthorizationStatus.value !== ''
  return hasCompany || hasStatus || hasAuthorization
})

const applyFilters = async () => {
  if (
    selectedCompanies.value.length === 0 &&
    selectedStatus.value === '' &&
    selectedAuthorizationStatus.value === ''
  ) {
    clearFilters()
    return
  }

  try {
    loading.value = true
    emit('apply-filters', {
      companies: selectedCompanies.value,
      ...(showStatusFilter && { isActive: selectedStatus.value }),
      ...(showAuthorizationStatusFilter && {
        authorizationStatus: selectedAuthorizationStatus.value
      })
    })
    emit('close')
  } catch (error) {
    console.error(error)
    toast.error('Erro ao aplicar filtros. Tente novamente.')
  } finally {
    loading.value = false
  }
}

const clearFilters = () => {
  try {
    loading.value = true
    selectedCompanies.value = []
    selectedStatus.value = ''
    selectedAuthorizationStatus.value = ''
    searchCompany.value = ''

    emit('apply-filters', {
      companies: [],
      ...(showStatusFilter && { isActive: '' }),
      ...(showAuthorizationStatusFilter && { authorizationStatus: '' })
    })
    emit('close')
  } catch (error) {
    console.error(error)
    toast.error('Erro ao limpar filtros. Tente novamente.')
  } finally {
    loading.value = false
  }
}

const close = () => {
  emit('close')
}

watchEffect(() => {
  if (props.modalStateProp) {
    if (props.appliedFilters) {
      selectedCompanies.value = props.appliedFilters.companies || []
      selectedStatus.value = props.appliedFilters.isActive || ''
      selectedAuthorizationStatus.value = props.appliedFilters.authorizationStatus || ''
    }
    searchCompany.value = ''
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: close,
    modalActive: _ctx.modalStateProp
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(OutlineButton, {
            onClick: close,
            text: "Cancelar",
            width: "180px"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(GhostButton, {
            loading: loading.value,
            onClick: clearFilters,
            text: "Limpar filtros",
            width: "180px"
          }, null, 8, ["loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(FilledButton, {
            disabled: !isFilterValid.value,
            loading: loading.value,
            onClick: applyFilters,
            text: "Aplicar Filtros",
            width: "180px"
          }, null, 8, ["disabled", "loading"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_autocomplete, {
          ref: "companyCombobox",
          modelValue: selectedCompanies.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCompanies).value = $event)),
          items: _unref(listCompanies),
          "item-title": "title",
          "item-value": "value",
          label: "Selecione as Empresas",
          multiple: "",
          chips: "",
          clearable: "",
          "deletable-chips": "",
          variant: "outlined",
          class: "w-full",
          "search-input": searchCompany.value,
          "onUpdate:searchInput": _cache[1] || (_cache[1] = ($event: any) => ((searchCompany).value = $event))
        }, null, 8, ["modelValue", "items", "search-input"]),
        (_unref(showStatusFilter))
          ? (_openBlock(), _createBlock(_component_v_select, {
              key: 0,
              modelValue: selectedStatus.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedStatus).value = $event)),
              items: statusOptions,
              label: "Status da Política",
              "item-title": "label",
              "item-value": "value",
              variant: "outlined",
              clearable: "",
              class: "w-full"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_unref(showAuthorizationStatusFilter))
          ? (_openBlock(), _createBlock(_component_v_select, {
              key: 1,
              modelValue: selectedAuthorizationStatus.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedAuthorizationStatus).value = $event)),
              items: authorizationOptions,
              label: "Status de Autorização",
              "item-title": "label",
              "item-value": "value",
              variant: "outlined",
              clearable: "",
              class: "w-full"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})